import React, { useState } from 'react';
import { Header } from './components/Header';
import { NewsList } from './components/NewsList';
import { SettingsButton } from './components/SettingsButton';
import { SettingsPanel } from './components/SettingsPanel';
import { ThemeProvider } from './components/ThemeProvider';
import { Footer } from './components/Footer';
import NewsTicker from './components/NewsTicker';
import { useRSSFeed } from './hooks/useRSSFeed';

function App() {
  const { feed, loading, error, options, updateOptions, refreshFeed } = useRSSFeed();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [currentTickerIndex, setCurrentTickerIndex] = useState(0);

  const toggleSettings = () => {
    setIsSettingsOpen(!isSettingsOpen);
  };

  return (
    <ThemeProvider options={options}>
      <div className="App">
        <NewsTicker 
          items={feed?.items || []} 
          speed={60 * options.tickerSpeed}
          height="60px"
          backgroundColor={options.theme === 'dark' ? '#1a1a1a' : '#2c3e50'}
          textColor={options.theme === 'dark' ? '#ffffff' : '#ecf0f1'}
          onCurrentItemChange={setCurrentTickerIndex}
        />
        <Header title="Feed de Notícias" onRefresh={refreshFeed} />
        <div className="container">
          <NewsList 
            feed={feed} 
            options={options} 
            loading={loading} 
            error={error}
            currentTickerIndex={currentTickerIndex}
          />
        </div>
        <Footer />
        <SettingsButton onClick={toggleSettings} />
        <SettingsPanel 
          options={options} 
          onUpdateOptions={updateOptions} 
          isOpen={isSettingsOpen} 
          onClose={() => setIsSettingsOpen(false)} 
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
